<template>
  <div class="self_evaluation">
    <div class="tabs">
      <span></span>翻译证书
    </div>
    <div class="upload_photo">
      <ul v-if="filePathList.length" class="imgList">
        <li ref="photoList" @mouseleave="leave(index)" @mouseenter="enter(index)" @click="removeZ(index)"
          v-for="(item,index) in filePathList" :key="index">
          <img :src="item" alt="">
          <span :class="{'delete':index == current}"></span>
        </li>
      </ul>
      <div v-if="isDisplay">
        <el-upload v-if="filePathList.length<=3" ref="upload" :file-list="fileArr" action
          :http-request="uploadSectionFile" :before-upload="beforeUploadFile" list-type="picture-card"
          :on-change="handlePictureCardPreview" accept=".jpg,.png,.jpeg,">
          <img style="position: absolute;left: 50%;top: 24px;transform: translateX(-50%);"
            src="../../assets/imgs/shangchuan.png" alt="">
          <span style="top: 80px;">上传语言证书</span>
          <span style="top:100px">支持jpg,png,jpeg</span>
        </el-upload>
      </div>

    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" top="40vh" width="20%">
      <span>确认删除该照片？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleZ">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  watch: {
    userInfo: {
      handler(newVale, oldVale) {
        if (newVale.num === 1) {
          this.id = newVale.id
          this.auditStatus = newVale.auditStatus
          if (this.auditStatus === 1) {
            this.isDisplay = false
          } else {
            this.isDisplay = true
          }
          if (newVale.certificateUrls) {
            this.filePathList = newVale.certificateUrls
            if (this.filePathList.length < 3 && !this.flag) {
              this.disP = true
              this.$refs.upload.$children[1].$el.style.visibility = "visible";
            } else {
              this.$refs.upload.$el.style.visibility = "hidden";
              this.disP = false
            }
          }

        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {

  },
  data() {
    return {
      id: null,
      auditStatus: null,
      dialogImageUrl: '',
      dialogVisible: false,
      filePathList: [],
      fileArr: [],
      current: null,
      dialogVisible: false,
      isDisplay: true,
    };
  },

  methods: {
    //鼠标 有移除
    leave(index) {
      this.current = null
    },
    //移入显示遮罩层
    enter(index) {
      if (!this.isDisplay) {
        return
      }
      this.current = index
    },
    //删除照片
    deleZ() {
      if (!this.isDisplay) {
        return
      }
      let that = this
      this.filePathList.splice(that.user_id, 1)
      if (this.filePathList.length < 3 && !this.flag) {
        this.disP = true
        that.$refs.upload.$children[1].$el.style.visibility = "visible";
        // that.$refs.upload.$el.style.visibility = "visible";
      } else {
        //that.$refs.upload.$children[1].$el.style.display = "none";
        that.$refs.upload.$el.style.visibility = "hidden";
        this.disP = false
      }
      this.dialogVisible = false
      this.submitPhoto(this.filePathList)
    },
    removeZ(id) {
      if (!this.isDisplay) {
        return
      }
      // console.log(id)
      if (this.flag) {
        this.dialogVisible = false
        return
      }
      let that = this
      this.user_id = id
      this.dialogVisible = true
      if (that.filePathList.length < 3) {
        that.$refs.upload.$el.style.visibility = "hidden";
      }
    },
    //点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file, fileList) {
      this.fileArr = fileList;
    },

    //上传前的校验
    beforeUploadFile(file) {
      let that = this;
      // let type = that.typeReg(file.name);
      let nameType = file.name.split(".");
      let type = nameType[nameType.length - 1];
      const isPNG = type === "png";
      const isJPG = type === "jpg";
      const isJPEG = type === "jpeg";
      if (!isPNG && !isJPG && !isJPEG) {
        that.$message({
          message: '文件格式不支持',
          type: 'warning'
        });
        return false;
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        that.$message({
          message: '图片大小不能超过 20MB!',
          type: 'warning'
        });
        return false;
      }
    },
    // 上传函数——获取签名
    uploadSectionFile(param) {
      var that = this;
      var fileObj = param.file;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      var type = resultArr[2];
      //自定义文件上传
      var url = `/v1/userRegister/getUploadSign`;
      var params = {
        fileType: "project"
      };
      this.catReq1Service(url, params).then(function (response) {
        if (!response.resultCode) {
          return;
        }
        let data = response.result;
        that.host = data.host;
        var key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", fileObj);
        that.getFileHost(param);
      });
    },
    // 上传的第二个函数
    getFileHost(param) {
      var that = this;
      var FileController = that.host;
      var config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({
            percent: complete
          });
        }
      };
      // this.catReq1Service(FileController, that.formData, config)
      axios
        .post(FileController, that.formData, config).then(async function (response) {
          if (!response) {
            return;
          }
          that.filePathList.push(response.data.result.fileUrl);
          await that.submitPhoto(that.filePathList)
          if (that.filePathList.length >= 3) {
            that.$refs.upload.$children[1].$el.style.visibility = "hidden";
          }
        });
    },
    async submitPhoto(filePathList) {
      let url = "/v1/userRegister/add_or_update_register_info"
      let myUser = JSON.parse(localStorage.getItem("myUser"))
      let params = {
        id: this.id,
        auditStatus: this.auditStatus === 0 ? 0 : 2,
        userId: myUser.id,
        certificateUrls: filePathList,
      }
      const res = await this.catReq1Service(url, params)
      if (res.resultCode === "1") {
        this.$emit("succe", res.result)
      }

    }

  },
};
</script>

<style lang="less" scoped>
.self_evaluation {
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
  }
  .upload_photo {
    display: flex;
    .imgList {
      li {
        position: relative;
        float: left;
      }
      img {
        width: 150px;
        height: 150px;
        margin-right: 20px;
      }
      span {
        cursor: pointer;
      }
      .delete {
        opacity: 0.7;
        position: absolute;
        left: 0;
        top: 0;
        display: inline-block;
        width: 150px;
        height: 150px;
        background-image: url("../../assets/imgs/delete_pictures.png");
      }
    }
  }
  /deep/.el-upload {
    position: relative;
    span {
      position: absolute;
      left: 50%;
      height: 20px;
      width: 100%;
      line-height: 20px;
      text-align: center;
      transform: translateX(-50%);
    }
  }
  /deep/.el-upload-list__item {
    display: none;
  }
  .add_work_experience {
    display: flex;
    cursor: pointer;
    float: left;
    margin-left: 10px;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background: url("../../assets/imgs/editor/add_to_normal.png") no-repeat;
      background-size: cover;
    }
    span {
      display: inline-block;
      line-height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-left: 5px;
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
/deep/.el-dialog {
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__body {
    text-align: center;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
